import { render, staticRenderFns } from "./DeliveryStatusAnalytics.vue?vue&type=template&id=3852ba91&"
import script from "./DeliveryStatusAnalytics.vue?vue&type=script&lang=js&"
export * from "./DeliveryStatusAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports